import moment from 'moment-timezone';
import React from 'react';
import { AutosaveIndicator } from '../AutosaveIndicator';
import { DraftPublishedChip } from './DraftPublishedChip';
import styles from './HeaderWithControls.module.css';
var Title = function (props) {
    return (React.createElement("div", { className: styles.header },
        React.createElement("div", { className: styles.display }, props.label)));
};
var InfoLine = function (props) {
    var updatedOn = moment(props.updatedOn).fromNow();
    return (React.createElement("div", { className: styles.infoContainer },
        React.createElement(DraftPublishedChip, { status: props.draftPublishedChipStatus }),
        React.createElement("div", { className: styles.info }, " \u00B7 Edited by " + props.updatedBy + " \u00B7 " + updatedOn),
        !!props.autoSaveIndicator && (React.createElement("div", { className: styles.status },
            React.createElement(AutosaveIndicator, { retryFunction: props.autoSaveIndicator.retry, saveState: props.autoSaveIndicator.status })))));
};
export var HeaderWithControls = function (props) {
    return (React.createElement("div", { className: styles.stickyHeader },
        React.createElement("div", { className: styles.headerContainer },
            React.createElement(Title, { label: props.title }),
            React.createElement("div", { className: styles.controls }, props.buttons)),
        React.createElement(InfoLine, { updatedBy: props.updatedBy, updatedOn: props.updatedOn, draftPublishedChipStatus: props.draftPublishedChipStatus, autoSaveIndicator: props.autoSaveIndicator })));
};
